import React from 'react';
import originLogoAndText from '../../assets/img/origin-icon-and-text.svg';

import '../../assets/css/HelpModal.css';
import version from '../../version.json';
import { Button, Modal } from 'react-bootstrap';

export interface Props {
    helpShow: boolean;
    helpHandleShow: any;
    helpHandleClose: any;
}

export const HelpModal: React.FC<Props> = (props) => {
    const lStyle = {
        width: '200px',
    };

    return (
        <>
            {props && (
                <Modal
                    size={'sm'}
                    bsPrefix={'modal'}
                    show={props.helpShow}
                    onHide={props.helpHandleClose}
                    animation={false}
                >
                    <Modal.Header
                        closeButton={true}
                        closeLabel='close'
                        onHide={props.helpHandleClose}
                        bsPrefix='modal-header'
                    >
                        <Modal.Title>About Origin</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='row'>
                            <div className='col p-0'>
                                <img src={originLogoAndText} alt='company logo' height='70px'></img>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col remove-left-padding p-2'>
                                <section>
                                    <label>
                                        Version:{' '}
                                        <span style={{ marginLeft: '2.5rem' }}>
                                            {version.versionNumber}
                                        </span>
                                    </label>
                                </section>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='primary' onClick={props.helpHandleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

export default HelpModal;
